import type { CategoryTree } from 'tradera/components/breadcrumbs/breadcrumbs';
import type { Category } from '../services/touchweb-syi-api';
import type {
    CompressedAttributeFilter,
    FilterPrice,
    QueryParams
} from 'tradera/apps/tradera/components/discover/components/filters/types';
import type { PaginationViewModel } from 'tradera/state/services/types/webapi-discover-generated';

export type FilterCategoriesType = {
    type?: string;
    parameter?: string;
    activeCategory?: Category;
    categoryTree?: CategoryTree;
};

export type InternalSearch = {
    showSearchBar?: boolean;
    placeholder?: string;
};

type Filter = {
    selectedValue: string;
    name: string;
    parameter: string;
    type: string;
    options: Option[];
    isIndexable: boolean;
    translateOptions: boolean;
};

type Option = {
    name: string;
    value: string;
    sortOrder: number;
    count: number;
};

export type DiscoverState = {
    activeBrands: [];
    activeFilters: [];
    attributeFilters: CompressedAttributeFilter[];
    categoryPath: {
        id: number;
        href: string;
        isTopLevel: boolean;
        selected: boolean;
        name: string;
    }[];
    currentCategoryId: number;
    endpoint: null;
    error: null;
    filterCategories: FilterCategoriesType;
    filterPrice: FilterPrice;
    filters: {
        itemType?: Filter;
        itemCondition?: Filter;
        sellerType?: Filter;
        itemStatus?: Filter;
        county?: Filter;
        sortBy?: Filter;
        allowedBuyerRegions?: Filter;
    };
    hasResult: boolean;
    headerText: string | null;
    internalSearch: InternalSearch;
    introText: string | null;
    isFetchingGeolocation: boolean;
    isFilterOpen: boolean;
    isSavedSearchEmailEnabled: boolean;
    isShopOwnedByCurrentMember: boolean;
    items: [];
    itemsOnDisplay: [];
    mainText: string | null;
    pagination: PaginationViewModel | null;
    queryParams: QueryParams;
    totalItems: number;
    reduxContainer: unknown;
    searchLanguages: [];
};

export const initialState: DiscoverState = {
    activeBrands: [],
    activeFilters: [],
    attributeFilters: [],
    categoryPath: [],
    currentCategoryId: 0,
    endpoint: null,
    error: null,
    filterCategories: {},
    filterPrice: {},
    filters: {},
    hasResult: false,
    headerText: null,
    internalSearch: {},
    introText: null,
    isFetchingGeolocation: false,
    isFilterOpen: false,
    isSavedSearchEmailEnabled: false,
    isShopOwnedByCurrentMember: false,
    items: [],
    itemsOnDisplay: [],
    mainText: null,
    pagination: null,
    queryParams: {},
    totalItems: 0,
    reduxContainer: {},
    searchLanguages: []
};
